import { useSelector } from 'react-redux';
import useIsLoggedIn from 'utils/hooks/use_is_logged_in';
import { getUserNavigationLinks } from '../utils/navigation_links';

const UserNavigationButtons = () => {
  const client = useSelector((state) => state.user || {});
  const { vendor_id: vendorId } = client;
  const isLoggedIn = useIsLoggedIn();

  const userNavLinks = getUserNavigationLinks(isLoggedIn, vendorId);

  return (
    <>
      {userNavLinks.map((nav) => (
        <li className="header-mobile__nav-item" key={`${nav.path}-${nav.name}`}>
          <a
            href={nav.path}
            className="d-flex align-items-center py-2"
            target={nav.target}
          >
            <i className={`${nav.iconClass} fa-fw icon__before-text`} />
            {nav.name}
          </a>
        </li>
      ))}
    </>
  );
};

export default UserNavigationButtons;
